export default __webpack_public_path__ + "static/media/back.1a62ebb7.svg";